












import Vue from "vue";
import foodimage from "@/assets/images/food.png";

export default Vue.extend({
  props: {
    text: { type: String },
    selected: { type: Boolean },
    noImage: { type: String, default: "" },
    fonts: { type: Object },
    colors: { type: Object }
  },
  data() {
    return {
      foodimage
    };
  }
});
